import React from "react";
import "./style.scss";

const Index = () => {
  return (
    <div className="dashboard-enroll-failed-container">
      <div className="inner-dashboard-enroll-failed-container">
        <h1 className="failed-icon">
          <i class="far fa-frown"></i>
        </h1>
        <h3 className="failed-title">Kunne ikke opprette abonnement</h3>
        <p className="failed-description">
          En uventet feil skjedde, vennligst kontakt kundeservice{" "}
          <a href="mailto:kontakt@leadfind.no">her</a> for videre assistanse
          vedrørende ditt kundeforhold.
        </p>
      </div>
    </div>
  );
};

export default Index;
